import React from "react"
import { useConfig } from "../utils/use-config"
import PoweredBy from "./PoweredBy"

type Props = {
  onClose: () => void
}

const Container: React.FC<Props> = ({ children, onClose }) => {
  const { headline, subheading, styles } = useConfig()
  return (
    <div className="hw-mb-4 hw-max-w-sm hw-w-full">
      <div className="hw-shadow-2xl hw-rounded-3xl hw-mb-4">
        <div className="hw-bg-yellow-100 hw-px-4 md:hw-px-6 hw-py-5 hw-rounded-t-3xl hw-relative" style={{ backgroundColor: styles?.headerBgColor, color: styles?.headerTextColor }}>
          <h2 className="hw-text-xl hw-font-semibold hw-mb-2">{headline || "How can we help?"}</h2>
          <p className="hw-opacity-75">
            {subheading || "Our customer success team usually responds within a few hours."}
          </p>
          <button type="button" className="hw-absolute hw-top-3 hw-right-3 hw-opacity-40 hover:hw-opacity-60" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" className="hw-h-6 hw-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="hw-px-4 md:hw-px-6 hw-py-5 hw-bg-white  hw-rounded-b-3xl">
          {children}
        </div>
      </div>
      <PoweredBy />
    </div>
  )
}

export default Container
